import * as React from "react";
import { useContext, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
function InfoDialog({ openModal, setOpenModal, description, title }) {
  const [open, setOpen] = React.useState(false);
  const handleClose = () => {
    setOpenModal(false);
    setOpen(false);
  };
  useEffect(() => {
    setOpen(openModal);
  }, [openModal]);
  return (
    <div>
      <Modal show={open} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body> {description}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
export default InfoDialog;
